import {
  HoneycombWebSDK,
  WebVitalsInstrumentation,
} from '@honeycombio/opentelemetry-web';
import { diag, DiagConsoleLogger, DiagLogLevel } from '@opentelemetry/api';
import { getWebAutoInstrumentations } from '@opentelemetry/auto-instrumentations-web';

let started = false;

export function initializeHoneyCombTelemetry() {
  if (started) return;
  started = true;

  const isDebugMode = import.meta.env.MODE !== 'production';
  const allowedOrigins = [import.meta.env.VITE_CLAIMSCORE_API_URL];

  if (isDebugMode) {
    diag.setLogger(new DiagConsoleLogger(), DiagLogLevel.DEBUG);
  }

  const sdk = new HoneycombWebSDK({
    serviceName: 'claimscore-ui',
    apiKey: import.meta.env.VITE_HONEY_COMB_API_KEY,
    endpoint: import.meta.env.VITE_API_BASE_URL,
    debug: isDebugMode,
    sampleRate: 1,
    instrumentations: [
      getWebAutoInstrumentations({
        '@opentelemetry/instrumentation-fetch': {
          propagateTraceHeaderCorsUrls: allowedOrigins,
          clearTimingResources: true,
        },
        '@opentelemetry/instrumentation-xml-http-request': {
          propagateTraceHeaderCorsUrls: allowedOrigins,
        },
      }),
      new WebVitalsInstrumentation(),
    ],
  });

  sdk.start();
}
